import { defineMessages } from "react-intl";

export const messages = defineMessages({
  selectAll: {
    id: "ari.management.updateForm.filterDropdown.selectAll",
    defaultMessage: "Select all"
  },
  selectNone: {
    id: "ari.management.updateForm.filterDropdown.selectNone",
    defaultMessage: "Unselect all"
  }
});